export const CORE_EXPENSES_REQUEST = "CORE_EXPENSES_REQUEST";
export const CORE_EXPENSES_SUCCESS = "CORE_EXPENSES_SUCCESS";
export const CORE_EXPENSES_FAILED = "CORE_EXPENSES_FAILED";
